import React, { Fragment, useState, useEffect, useContext } from "react";
import {
  Container,
  Row,
  FormGroup,
  Col,
  Input,
  Card,
  CardBody,
  CardHeader,
  Table,
  Media,
} from "reactstrap";
import Greeting from "./Greeting";
import { generateClient } from "aws-amplify/api";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import * as queries from "../../../graphql/queries";
import * as mergedQueries from "../../../graphql/mergedQueries";
import SPCompany from "../../../Data/SPCompanyData/index";
import SiteData from "../../../Data/Sites/index";
import CategoryData from "../../../Data/Category/index";
import AssetTemplate from "../../../Data/AssetTemplate/index";
import SiteDBData from "../../../Data/DistributionBoard/index";
import { limit } from "../../../Config/Config";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import avtar from "../../../assets/images/avatar.jpg";
import { Bar } from "react-chartjs-2";
import { H6, Image, H4, H5, P } from "../../../AbstractElements";
import { SiteContext } from "../../../App";
import { aocontext } from "../../../App";
import Chart from "react-apexcharts";
import CommenHeader from "../../Charts/Commen";
import ScrollBar from "react-perfect-scrollbar";
import AWS from "aws-sdk";
import moment from "moment";
var base64 = require("base-64");

const DefaultContain = () => {
  const primary = "#5c61f2";
  const LoginUserDetails = JSON.parse(localStorage.getItem("userDetails"));
  const LoginUserGroup = localStorage.getItem("groups");
  const [isLoading, setIsLoading] = useState(false);
  const [nextTesting, setNextTesting] = useState(0);
  const [repair, setRepair] = useState(0);
  const [tasks, settasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingrepair, setLoadingrepair] = useState(false);
  const [tasksSU, settasksSU] = useState(0);
  const [testing, setTesting] = useState([]);
  const [testingAsset, setTestingAsset] = useState([]);
  const currentDate = new Date();
  const options1 = { day: "2-digit", month: "2-digit", year: "numeric" };
  const formattedDate = currentDate.toLocaleDateString("en-AU", options1);

  const { selectedSiteGlobal, handleSiteChange } = useContext(SiteContext);
  const { selectedAssetOwnerGlobal, handleAssetOwner } = useContext(aocontext);

  const client = generateClient({
    headers: {
      "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
    },
  });

  const cognito = new AWS.CognitoIdentityServiceProvider({
    region: "ap-southeast-2",
  });
  //---
  //-------single Calendar-----
  const [dateRange, setDateRange] = useState([null, null]);
  function SingleCalendar() {
    const [startDate, endDate] = dateRange;
    const handleDateRangeChange = (dates) => {
      if (dates && dates.length === 2) {
        setDateRange(dates);
      }
    };
    return (
      <Fragment>
        <Row className="d-flex justify-content-end">
          <Col xl="6">
            <div className="daterange-card">
              <div className="mb-3">
                <FormGroup>
                  <DatePicker
                    className="form-control digits"
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={handleDateRangeChange}
                    isClearable={true}
                    placeholderText="Enter Date Range"
                    dateFormat="dd-MM-yyyy"
                  />
                </FormGroup>
              </div>
            </div>
          </Col>
        </Row>
      </Fragment>
    );
  }
  //-------------Daterange Start-----------------------------------------------------
  const [selectedOption, setSelectedOption] = useState("All Time");
  const [dateRange1, setDateRange1] = useState([new Date(), new Date()]);
  const [series, setSeries] = useState([]);
  const [fulldata, setFulldata] = useState([]);
  const [seriesrepair, setSeriesrepair] = useState([]);
  const handleDateRangeSelected = (range) => {
    setDateRange1(range);
    console.log(range);
  };
  const onDateRangeSelected = (range) => {
    //setSelectedOption("");
    handleDateRangeSelected(range);
  };
  function DateRangePicker({ onDateRangeSelected }) {
    //const [selectedOption, setSelectedOption] =  useState('');

    const handleOptionChange = (event) => {
      setSelectedOption(event.target.value);
      console.log(event.target.value);

      switch (event.target.value) {
        case "Today":
          onDateRangeSelected(getTodayRange());

          break;
        case "This Week":
          onDateRangeSelected(getWeekRange());

          break;
        case "This Month":
          onDateRangeSelected(getMonthRange());

          break;
        case "This Year":
          onDateRangeSelected(getThisYearRange());

          break;
        case "All Time":
          onDateRangeSelected(getAllTimeRange());

          break;

        default:
          break;
      }
    };
    //---------------------------------------------------------------------------
    const getTodayRange = () => {
      let sd = JSON.parse(base64.decode(localStorage.getItem("site")));
      console.log("sites", sd)
      const activeee = sd.filter((item) => item.status === "Active");
      fetchRepairDetails(sd, "Today");
      fetchTestingss(sd, "Today");
      if (LoginUserGroup === "electrician") {
        fetchTasksSPLogin("Today");
      } else {
        fetchTasks(activeee, "Today");
      }
    };
    //---------------------------------------------------------------------------
    const getAllTimeRange = () => {
      let sd = JSON.parse(base64.decode(localStorage.getItem("site")));
      console.log("sites", sd)
      const activeee = sd.filter((item) => item.status === "Active");
      // fetchRepairDetails(sd, "All Time");
      // fetchTestingss(sd, "All Time");
      if (LoginUserGroup === "electrician") {
        fetchTasksSPLogin("All Time");
      } else {
        fetchTasks(activeee, "All Time");
      }
      const start = new Date(0);
      const end = new Date();
      const controller = new AbortController();
      console.log((onDateRangeSelected = { onDateRangeSelected }));
      return [start, end];
      //--

    };
    //---------------------------------------------------------------------------
    const getWeekRange = () => {
      let sd = JSON.parse(base64.decode(localStorage.getItem("site")));
      console.log("sites", sd);
      const activeee = sd.filter((item) => item.status === "Active");
      fetchRepairDetails(sd, "This Week");
      fetchTestingss(sd, "This Week");
      if (LoginUserGroup === "electrician") {
        fetchTasksSPLogin("This Week");
      } else {
        fetchTasks(activeee, "This Week");
      }
      const currentDate = new Date();
      const currentDayOfWeek = currentDate.getDay();
      const startOfWeek = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() - currentDayOfWeek
      );
      const endOfWeek = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() + (6 - currentDayOfWeek)
      );

      const today = new Date();
      console.log(today);
      console.log(moment(startOfWeek).format("DD/MM/YYYY"));

      console.log(endOfWeek);
      console.log((onDateRangeSelected = { onDateRangeSelected }));
      return [startOfWeek, endOfWeek];
    };
    //-----------------------------------------------------------------------
    const getMonthRange = () => {
      console.log("month range");
      let sd = JSON.parse(base64.decode(localStorage.getItem("site")));
      console.log("sites", sd);
      const activeee = sd.filter((item) => item.status === "Active");
      fetchRepairDetails(sd, "This Month");
      fetchTestingss(sd, "This Month");
      if (LoginUserGroup === "electrician") {
        fetchTasksSPLogin("This Month");
      } else {
        fetchTasks(activeee, "This Month");
      }
      const currentDate = new Date();
      const startOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      const endOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
      );
      console.log((onDateRangeSelected = { onDateRangeSelected }));
      return [startOfMonth, endOfMonth];
    };
    //---------------------------------------------------------------------------
    const getThisYearRange = () => {
      const currentDate = new Date();
      const startOfThisYear = new Date(currentDate.getFullYear(), 0, 1);
      const endOfThisYear = new Date(currentDate.getFullYear(), 11, 31);
      console.log((onDateRangeSelected = { onDateRangeSelected }));
      return [startOfThisYear, endOfThisYear];
    };
    //---------------------------------------------------------------------------------
    return (
      <div className="daterange-card">
        <Row>
          <Col xs="6">
            <FormGroup>
              <Input
                type="select"
                value={selectedOption}
                onChange={handleOptionChange}
              >
                <option
                  value="All Time"
                  selected={selectedOption === "All Time"}
                >
                  All Time
                </option>
                <option value="Today" selected={selectedOption === "Today"}>
                  Today
                </option>
                <option
                  value="This Week"
                  selected={selectedOption === "This Week"}
                >
                  This Week
                </option>
                <option
                  value="This Month"
                  selected={selectedOption === "This Month"}
                >
                  This Month
                </option>
                {/* <option
                  value="This Year"
                  selected={selectedOption === "This Year"}
                >
                  This Year
                </option> */}
                <option value="Custom" selected={selectedOption === "Custom"}>
                  Custom
                </option>
              </Input>
            </FormGroup>
          </Col>
          <Col xs="6">
            <FormGroup>
              {selectedOption === "Custom" && (
                <SingleCalendar onDateRangeSelected={onDateRangeSelected} />
              )}
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }

  useEffect(() => {
    //
    fetchCategory();
    fetchAssetTemplate();

    if (LoginUserGroup === "site_user") {
      fetchSPCompanySU(LoginUserDetails);
      fetchSiteDetailsSU();
    } else if (LoginUserGroup === "electrician") {
      fetchSPCompanySP(LoginUserDetails.id);
      fetchSiteDetailsSP(LoginUserDetails.id);
    }
    dashboardCount(LoginUserDetails.id);
    //fetchAssets();
    if (LoginUserGroup === "electrician") {
      fetchTasksSPLogin();
    } else {
      // fetchTasks();
    }
  }, []);

  async function dashboardCount(user) {
    try {
      const getdata = await client.graphql({
        query: queries.listDashboardCounts,
        authMode: "API_KEY",
        variables: {
          limit: 10000,
          filter: {
            userId: {
              eq: user,
            },
          },
        },
      });
      console.log("data ", getdata);
      if (getdata.data.listDashboardCounts.items.length > 0) {
        console.log(getdata.data.listDashboardCounts.items);
        setFulldata(getdata.data.listDashboardCounts.items);
      }
    } catch (error) {
      console.error(error);
    }
  }

  //---spuser
  async function fetchSpuser(sites) {
    //--
    try {
      let userIds = [];
      let nextToken1 = "";
      console.log(sites);
      const filterSites = sites.filter(
        (item) => item.id === selectedSiteGlobal
      );
      const filtersitesss = selectedSiteGlobal ? filterSites : sites;
      if (filtersitesss.length > 0) {
        for (let site of filtersitesss) {
          const getSiteIds = await client.graphql({
            query: queries.linkUsersAndSitesBySitedetailsID,
            authMode: "API_KEY",
            variables: {
              sitedetailsID: site.id,
              filter: {
                status: {
                  eq: "Active",
                },
              },
            },
          });
          console.log(getSiteIds);
          if (
            getSiteIds.data.linkUsersAndSitesBySitedetailsID.items.length > 0
          ) {
            nextToken1 =
              getSiteIds.data.linkUsersAndSitesBySitedetailsID.nextToken;
            userIds.push(
              getSiteIds.data.linkUsersAndSitesBySitedetailsID.items
            );
            while (nextToken1 !== null) {
              const getSiteIds1 = await client.graphql({
                query: queries.linkUsersAndSitesBySitedetailsID,
                authMode: "API_KEY",
                variables: {
                  sitedetailsID: site.id,
                  filter: {
                    status: {
                      eq: "Active",
                    },
                  },
                  nextToken: nextToken1,
                },
              });
              console.log(getSiteIds1);
              if (
                getSiteIds1.data.linkUsersAndSitesBySitedetailsID.items.length >
                0
              ) {
                nextToken1 =
                  getSiteIds1.data.linkUsersAndSitesBySitedetailsID.nextToken;
                userIds.push(
                  getSiteIds1.data.linkUsersAndSitesBySitedetailsID.items
                );
              }
            }
            console.log(userIds);
            if (userIds.length > 0) {
              const mergeUserIds = userIds.flat(1);
              const response1 = await client.graphql({
                query: queries.listSPUserDetails,
                authMode: "API_KEY",
                variables: {
                  // filter: {
                  //   userGroup: {
                  //     eq: "electrician",
                  //   },
                  // },
                  limit: 200000,
                },
              });
              console.log(response1);
              if (response1.data.listSPUserDetails.items.length > 0) {
                const spDetails2 =
                  response1.data.listSPUserDetails.items.filter((item) => {
                    const _matchSites = mergeUserIds?.find(
                      (user) => user.userdetailsID === item?.id
                    );
                    if (_matchSites) {
                      return item;
                    }
                  });
                console.log(spDetails2);
                const sortedItems = spDetails2.sort((a, b) => {
                  return new Date(b.createdAt) - new Date(a.createdAt);
                });
                console.log(sortedItems);
                localStorage.setItem(
                  "spuser",
                  base64.encode(JSON.stringify(sortedItems))
                );
              }
            } else {
            }
          }
        }
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  }

  // async function plotTestsGraph(sitesdata, from, to) {
  //   try {
  //     setLoading(true);
  //     const dailyCountsMap = {};

  //     await Promise.all(
  //       sitesdata.map(async (siteId) => {
  //         let allItems = [];
  //         let nextToken = null;

  //         // Loop through pages using nextToken
  //         do {
  //           const { data } = await client.graphql({
  //             query: queries.testingsBySitedetailsID,
  //             variables: {
  //               sitedetailsID: siteId.id,
  //               limit: 1000,
  //               nextToken,
  //               filter: {
  //                 createdAt: {
  //                   between: [from, to],
  //                 },
  //               },
  //             },
  //           });

  //           const result = data.testingsBySitedetailsID;
  //           allItems = allItems.concat(result.items || []);
  //           nextToken = result.nextToken;
  //         } while (nextToken);

  //         console.log("Querying from:", from, "to:", to);
  //         console.log("items-", siteId.siteName, allItems.length);

  //         // Group by day
  //         allItems.forEach((item) => {
  //           const day = moment(item.createdAt).format("YYYY-MM-DD");
  //           dailyCountsMap[day] = (dailyCountsMap[day] || 0) + 1;
  //         });
  //       })
  //     );

  //     const last7Days = Array.from({ length: 7 }).map((_, i) => {
  //       const dayLabel = moment().subtract(6 - i, "days").format("MMM D");
  //       const dayKey = moment().subtract(6 - i, "days").format("YYYY-MM-DD");
  //       return {
  //         x: dayLabel,
  //         y: dailyCountsMap[dayKey] || 0,
  //       };
  //     });
  //     setLoading(false);
  //     setSeries([
  //       {
  //         name: "Total Tests",
  //         data: last7Days.map(item => item.y),
  //       },
  //     ]);

  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  //   finally {
  //     setLoading(false);
  //   }
  // }

  async function plotTestsGraph(selectedSites) {
    try {
      setLoading(true);

      const siteIds = selectedSites.map(site => site.id);

      const { data } = await client.graphql({
        query: queries.getTestsPast7Days,
        variables: { siteIds },
        authMode: "API_KEY",
      });

      console.log("7 days", data);
      const dailyData = data.getTestsPast7Days || [];

      const chartData = dailyData.map(item => ({
        x: moment(item.date).format("MMM D"),
        y: item.totalTests,
      }));

      setSeries([
        {
          name: "Total Tests",
          data: chartData.map(d => d.y),
        },
      ]);

    } catch (error) {
      console.error("Error fetching 7-day test data:", error);
    } finally {
      setLoading(false);
    }
  }

  // async function plotRepairGraph(sitesdata, from, to) {
  //   try {
  //     setLoadingrepair(true);
  //     const assetTemplates = [];
  //     let nextToken = null;

  //     do {
  //       const res = await client.graphql({
  //         query: queries.listAssetTemplates,
  //         variables: {
  //           limit: 200000,
  //           nextToken: nextToken,
  //         },
  //         authMode: "API_KEY",
  //       });

  //       const items = res.data.listAssetTemplates.items;
  //       if (items && items.length > 0) {
  //         assetTemplates.push(...items);
  //       }
  //       nextToken = res.data.listAssetTemplates.nextToken;
  //     } while (nextToken);

  //     console.log("Total assetTemplates:", assetTemplates.length);

  //     const dailyCountsMap = {};
  //     let count = 0;

  //     let repairs = [];
  //     let token = null;
  //     for (const assetTemplate of assetTemplates) {
  //       count++;
  //       for (const site of sitesdata) {
  //         const assettemplateSiteID = `${assetTemplate.id}_${site.id}`;
  //         console.log("site assettempId", assettemplateSiteID)

  //         do {
  //           const res = await client.graphql({
  //             query: queries.repairsByAssettemplateSiteID,
  //             variables: {
  //               assettemplateSiteID: assettemplateSiteID,
  //               limit: 1000,
  //               nextToken: token,
  //               filter: {
  //                 createdAt: {
  //                   between: [from, to],
  //                 },
  //               },
  //             },
  //             authMode: "API_KEY",
  //           });
  //           console.log("result", res.data.repairsByAssettemplateSiteID.items);
  //           const result = res.data.repairsByAssettemplateSiteID;
  //           if (result.items && result.items.length > 0) {
  //             repairs.push(...result.items);
  //           }
  //           token = result.nextToken;
  //         } while (token);
  //       }
  //       if (count === assetTemplates.length) {
  //         console.log("Total repairs:", repairs);
  //         repairs.forEach((item) => {
  //           const day = moment(item.createdAt).format("YYYY-MM-DD");
  //           dailyCountsMap[day] = (dailyCountsMap[day] || 0) + 1;
  //         });
  //       }
  //     }

  //     const last7Days = Array.from({ length: 7 }).map((_, i) => {
  //       const dayLabel = moment().subtract(6 - i, "days").format("MMM D");
  //       const dayKey = moment().subtract(6 - i, "days").format("YYYY-MM-DD");
  //       return {
  //         x: dayLabel,
  //         y: dailyCountsMap[dayKey] || 0,
  //       };
  //     });
  //     setLoadingrepair(false);
  //     setSeriesrepair([
  //       {
  //         name: "Total Tests",
  //         data: last7Days.map(item => item.y),
  //       },
  //     ]);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  //   finally {
  //     setLoadingrepair(false);
  //   }
  // }

  async function plotRepairGraph(selectedSites) {
    try {
      setLoadingrepair(true);
      const siteIds = selectedSites.map(site => site.id);
      const { data } = await client.graphql({
        query: queries.repairCounts,
        variables: { siteIds },
        authMode: "API_KEY",
      });

      console.log("7 days", data);
      const repairs = data.repairCounts;

      const seriesData = [
        {
          name: "Total Repairs",
          data: repairs.map((d) => d.totalRepairs),
        },
      ];

      const xCategories = repairs.map((d) => moment(d.date).format("MMM D"));

      setSeriesrepair(seriesData);

    } catch (error) {
      console.error("Error fetching repairs:", error);
    } finally {
      setLoadingrepair(false);
    }
  }


  async function fetchSPCompanySU(user) {

    try {
      const invitedByUserData = await client.graphql({
        query: queries.getUserDetails,
        variables: {
          id: user.assetOwnerId,
          limit: 10000,
        },
        authMode: "API_KEY",
      });

      const params = {
        UserPoolId: "ap-southeast-2_Y8sY9qqTz",
        Username: invitedByUserData.data.getUserDetails.username,
      };

      const cognitoUser = await new Promise((resolve, reject) => {
        cognito.adminGetUser(params, function (err, data) {
          if (err) {
            console.log(err, err.stack);
            reject(err);
          } else {
            resolve(data);
          }
        });
      });
      console.log("user  ..", cognitoUser)
      const userType = cognitoUser.UserAttributes.find(attr => attr.Name === "custom:userType")?.Value;

      console.log("su invited by spao", userType);

      if (userType === "spao") {
        const getLinkAOAPCompanyDetails = await client.graphql({
          query: queries.getSPUserDetails,
          authMode: "API_KEY",
          variables: {
            id: user.assetOwnerId,
          },
        });

        console.log("getLinkAOAPCompanyDetails", user);
        console.log("getLinkAOAPCompanyDetails", getLinkAOAPCompanyDetails);

        if (getLinkAOAPCompanyDetails.data.getSPUserDetails !== null) {
          const spcompId = getLinkAOAPCompanyDetails.data.getSPUserDetails.spcompanydetailsID;
          console.log(spcompId);

          const getcompany = await client.graphql({
            query: queries.linkAOAPCompaniesBySpaoId,
            authMode: "API_KEY",
            variables: {
              spaoId: user.assetOwnerId,
              filter: {
                spcomapnyId: {
                  eq: spcompId,
                },
              },
              limit: 100000,
            },
          });

          console.log("spcommapny", getcompany);
          if (getcompany.data.linkAOAPCompaniesBySpaoId.items.length > 0) {
            SPCompany.setSPCompany(getcompany.data.linkAOAPCompaniesBySpaoId.items);
            localStorage.setItem("spCompany", base64.encode(
              JSON.stringify(getcompany.data.linkAOAPCompaniesBySpaoId.items)
            ));
          }
        }
      } else {
        const getLinkAOAPCompanyDetails = await client.graphql({
          query: queries.linkAOAPCompaniesBySpaoId,
          authMode: "API_KEY",
          variables: {
            spaoId: user.assetOwnerId,
          },
        });

        console.log("getLinkAOAPCompanyDetails", user);
        console.log("getLinkAOAPCompanyDetails", getLinkAOAPCompanyDetails);

        if (getLinkAOAPCompanyDetails.data.linkAOAPCompaniesBySpaoId.items.length > 0) {
          SPCompany.setSPCompany(getLinkAOAPCompanyDetails.data.linkAOAPCompaniesBySpaoId.items);
          localStorage.setItem("spCompany", base64.encode(
            JSON.stringify(getLinkAOAPCompanyDetails.data.linkAOAPCompaniesBySpaoId.items)
          ));
        }
      }
    } catch (error) {
      console.log("Error in fetchSPCompanySU:", error);
      setIsLoading(false);
    }
  }


  // async function fetchSPCompanySP(sPId) {
  //   try {
  //     const getLinkAOAPCompanyDetails = await client.graphql({
  //       query: queries.listLinkAOAPCompanies,
  //       authMode: "API_KEY",
  //       variables: {
  //         limit: 10000,
  //         filter: {
  //           spaoId: {
  //             eq: sPId,
  //           },
  //         },
  //       },
  //     });
  //     console.log("getLinkAOAPCompanyDetails", sPId);
  //     console.log("getLinkAOAPCompanyDetails", getLinkAOAPCompanyDetails);
  //     if (
  //       getLinkAOAPCompanyDetails.data.listLinkAOAPCompanies.items.length > 0
  //     ) {
  //       SPCompany.setSPCompany(
  //         getLinkAOAPCompanyDetails.data.listLinkAOAPCompanies.items
  //       );
  //       localStorage.setItem(
  //         "spCompany",
  //         base64.encode(
  //           JSON.stringify(
  //             getLinkAOAPCompanyDetails.data.listLinkAOAPCompanies.items
  //           )
  //         )
  //       );
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setIsLoading(false);
  //   }
  // }

    async function fetchSPCompanySP() {
    try {
      const result = await client.graphql({
        query: queries.getCompaniesByLoginUser,
        variables: {
          loginuserdetailsId: LoginUserDetails.id,
        },
      });

      console.log("sp company", result);
      SPCompany.setSPCompany(
        result.data.getCompaniesByLoginUser
      );
      localStorage.setItem(
        "spCompany",
        base64.encode(
          JSON.stringify(
            result.data.getCompaniesByLoginUser
          )
        )
      );
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  async function fetchCategory() {
    try {
      let nextToken = "";
      let categories = [];
      const dataDetails = await client.graphql({
        query: queries.listCategories,
        authMode: "API_KEY",
        variables: {
          limit: limit,
        },
      });
      if (dataDetails.data.listCategories.items.length > 0) {
        let assetDatas = dataDetails.data.listCategories.items;
        nextToken = dataDetails.data.listCategories.nextToken;
        if (dataDetails.data.listCategories.items.length > 0) {
          categories.push(assetDatas);
        }
        while (nextToken !== null) {
          const dataDetailss = await client.graphql({
            query: queries.listCategories,
            variables: {
              limit: limit,
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          if (dataDetailss.data.listCategories.items.length > 0) {
            nextToken = dataDetailss.data.listCategories.nextToken;
            if (dataDetailss.data.listCategories.items.length > 0) {
              categories.push(dataDetailss.data.listCategories.items);
            }
          }
          else {
            nextToken = null;
          }
        }
        console.log(categories);
        if (categories.length > 0) {
          const mergeCategories = categories.flat(1);
          localStorage.setItem(
            "category",
            base64.encode(JSON.stringify(mergeCategories))
          );
          CategoryData.setCategoryData(mergeCategories);
          setIsLoading(false);
        }
      }
    } catch (error) {
      console.log(error);
      CategoryData.setCategoryData([]);
      setIsLoading(false);
    }
  }

  async function fetchAssetTemplate() {
    try {
      let nextToken = "";
      let assetTemplates = [];
      const dataDetails = await client.graphql({
        query: queries.listAssetTemplates,
        authMode: "API_KEY",
        variables: {
          limit: limit,
        },
      });
      if (dataDetails.data.listAssetTemplates.items.length > 0) {
        let assetDatas = dataDetails.data.listAssetTemplates.items;
        nextToken = dataDetails.data.listAssetTemplates.nextToken;
        if (dataDetails.data.listAssetTemplates.items.length > 0) {
          assetTemplates.push(assetDatas);
        }
        while (nextToken !== null) {
          const dataDetailss = await client.graphql({
            query: queries.listAssetTemplates,
            variables: {
              limit: limit,
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          if (dataDetailss.data.listAssetTemplates.items.length > 0) {
            nextToken = dataDetailss.data.listAssetTemplates.nextToken;
            if (dataDetailss.data.listAssetTemplates.items.length > 0) {
              assetTemplates.push(dataDetailss.data.listAssetTemplates.items);
            }
          }
          else {
            nextToken = null;
          }
        }
        console.log(assetTemplates);
        if (assetTemplates.length > 0) {
          const mergeAssetTemplates = assetTemplates.flat(1);
          localStorage.setItem(
            "assetTemp",
            base64.encode(JSON.stringify(mergeAssetTemplates))
          );
          AssetTemplate.setAssetTemplate(mergeAssetTemplates);
          setIsLoading(false);
        }
      }
    } catch (error) {
      console.log(error);
      AssetTemplate.setAssetTemplate([]);
      setIsLoading(false);
    }
  }

  async function fetchSiteDetailsSU() {
    try {
      //setIsLoading(true);
      const response = await client.graphql({
        query: mergedQueries.getSiteUsersFromLink,
        authMode: "API_KEY",
        variables: {
          //nextToken: '',
          assetownerID: LoginUserDetails.assetOwnerId,
          userdetailsID: LoginUserDetails.id,
        },
      });
      console.log(response);
      let nextToken = "";
      let sitess = [];
      if (response.data.siteDetailsByAssetownerID.items.length > 0) {
        let sites = response.data.siteDetailsByAssetownerID.items;
        nextToken = response.data.siteDetailsByAssetownerID.nextToken;
        for (let site of sites) {
          //console.log(site);
          console.log(site.LinkUsersAndSites.items.length);
          if (site.LinkUsersAndSites.items.length > 0) {
            sitess.push(site);
          }
        }
        while (nextToken !== null) {
          const results = await client.graphql({
            query: mergedQueries.getSiteUsersFromLink,
            variables: {
              nextToken: nextToken,
              assetownerID: LoginUserDetails.assetOwnerId,
              userdetailsID: LoginUserDetails.id,
            },
            authMode: "API_KEY",
          });
          nextToken = results.data.siteDetailsByAssetownerID.nextToken;
          sites = results.data.siteDetailsByAssetownerID.items;
          for (let site of sites) {
            //console.log(site);
            console.log(site.LinkUsersAndSites.items.length);
            if (site.LinkUsersAndSites.items.length > 0) {
              sitess.push(site);
            }
          }
        }
        console.log(sitess);
        if (sitess.length > 0) {
          const mergeSites = sitess.flat(1);
          const from = moment()
            .subtract(7, "days")
            .startOf("day")
            .toISOString();
          const to = moment().endOf("day").toISOString();
          const activeSites = mergeSites.filter((item) => item.status === "Active");
          //fetchlistDistributionBox(mergeSites);
          console.log("SU sites", mergeSites);
          console.log("SU active sites", activeSites);
          //fetchRepairDetails(activeSites, "All Time");
          fetchTasks(activeSites, "All Time");
          plotRepairGraph(activeSites);
          //fetchTestingss(activeSites);
          plotTestsGraph(activeSites)
          //fetchSpuser(mergeSites);
          SiteData.setSiteData(mergeSites);
          localStorage.setItem(
            "site",
            base64.encode(JSON.stringify(mergeSites))
          );
        }
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  //--sites for sp/su
  async function fetchSiteDetailsSP(assetOwnerId) {
    //
    let nextToken = "";
    let sites = [];
    const result = await client.graphql({
      query: queries.linkUsersAndSitesByUserdetailsID,
      authMode: "API_KEY",
      variables: {
        userdetailsID: assetOwnerId,
        filter: {
          status: {
            eq: "Active",
          },
        },
        limit: limit,
      },
    });
    if (result.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
      let assetDatas = result.data.linkUsersAndSitesByUserdetailsID.items;
      nextToken = result.data.linkUsersAndSitesByUserdetailsID.nextToken;
      sites.push(assetDatas);
      while (nextToken !== null) {
        const results = await client.graphql({
          query: queries.linkUsersAndSitesByUserdetailsID,
          authMode: "API_KEY",
          variables: {
            userdetailsID: assetOwnerId,
            filter: {
              status: {
                eq: "Active",
              },
            },
            limit: limit,
            nextToken: nextToken,
          },
        });
        nextToken = results.data.linkUsersAndSitesByUserdetailsID.nextToken;
        if (results.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
          sites.push(results.data.linkUsersAndSitesByUserdetailsID.items);
        }
      }
      console.log(sites);
      if (sites.length > 0) {
        const mergesites = sites.flat(1);
        let sitesforUsers = [];
        const promises = mergesites.map(async (item) => {
          return await client.graphql({
            query: queries.getSiteDetails,
            variables: {
              id: item.sitedetailsID,
            },
            authMode: "API_KEY",
          });
        });
        Promise.all(promises).then((sitesData) => {
          sitesData.forEach((sites) => {
            if (sites.data.getSiteDetails !== null) {
              sitesforUsers.push(sites.data.getSiteDetails);
            }
          });
          //fetchlistDistributionBox(sitesforUsers);
          //fetchRepairDetails(sitesforUsers);
          //fetchTestingss(sitesforUsers);
          //--
          const from = moment()
            .subtract(7, "days")
            .startOf("day")
            .toISOString();
          const to = moment().endOf("day").toISOString();
          plotRepairGraph(sitesforUsers);
          plotTestsGraph(sitesforUsers)
          //fetchSpuser(sitesforUsers);
          // setSites(sitesforUsers);
          // setSiteDetails(sitesforUsers);
          localStorage.setItem(
            "site",
            base64.encode(JSON.stringify(sitesforUsers))
          );
          //SiteData.setSiteData(sitesforUsers);
        });
        // for (let site of mergesites) {
        //   const sitesData = await client.graphql({
        //     query: queries.getSiteDetails,
        //     variables: {
        //       id: site.id,
        //     },
        //     authMode: "API_KEY",
        //   });
        //   if (sitesData.data.getSiteDetails !== null) {
        //     sitesforUsers.push(sitesData.data.getSiteDetails);
        //     setSites(sitesforUsers);
        //     setSiteDetails(sitesforUsers);
        //     localStorage.setItem(
        //       "site",
        //       base64.encode(JSON.stringify(sitesforUsers))
        //     );
        //     SiteData.setSiteData(sitesforUsers);
        //   }
        // }
      }
    }
  }

  async function fetchlistDistributionBox(siteData) {
    try {
      const promises = siteData.map((item) => {
        return client.graphql({
          query: queries.distributionBoxesBySitedetailsID,
          variables: {
            sitedetailsID: item.id,
            limit: limit,
          },
        });
      });
      Promise.all(promises)
        .then(async (results) => {
          console.log(results);
          let SiteDB = [];
          results.map((items) => {
            if (items.data.distributionBoxesBySitedetailsID.items.length > 0) {
              SiteDB.push(items.data.distributionBoxesBySitedetailsID.items);
            }
          });
          if (SiteDB.length > 0) {
            console.log(SiteDB.flat(1));
            localStorage.setItem(
              "siteDB",
              base64.encode(JSON.stringify(SiteDB.flat(1)))
            );
            SiteDBData.setSiteDBData(SiteDB.flat(1));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }

  // site user testings
  async function fetchAssets() {
    const dataDetails = await client.graphql({
      query: queries.linkUsersAndSitesByUserdetailsID,
      authMode: "API_KEY",
      variables: {
        userdetailsID: LoginUserDetails.id,
        filter: {
          status: {
            eq: "Active",
          },
        },
        limit: limit,
      },
    });
    if (dataDetails.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
      const siteDetails =
        dataDetails.data.linkUsersAndSitesByUserdetailsID.items;
      if (siteDetails.length > 0) {
        const promises = siteDetails.map(async (item) => {
          return client.graphql({
            query: queries.getSiteDetails,
            variables: {
              id: item.sitedetailsID,
            },
          });
        });
        Promise.all(promises).then(async (results) => {
          console.log(results);
          let siteDetail = [];
          if (results.length > 0) {
            results.map((site) => {
              if (site.data.getSiteDetails !== null)
                siteDetail.push(site.data.getSiteDetails);
            });
            const data = siteDetail.filter(
              (item) => item.assetownerID === selectedAssetOwnerGlobal
            );
            const filterdata = selectedAssetOwnerGlobal ? data : siteDetail;
            console.log(filterdata);
            let siteIds = [];
            if (filterdata.length > 0) {
              // filterdata.map((item) => {
              //   siteIds.push(item.id);
              // });
              //fetchTestingss(filterdata);
              console.log(siteIds);
              let filter = {};
              if (selectedOption === "Today") {
                filter = {
                  createdAt: {
                    ge: moment().startOf("day").toISOString(),
                    le: moment().endOf("day").toISOString(),
                  },
                };
              } else if (selectedOption === "This Week") {
                filter = {
                  createdAt: {
                    ge: moment().startOf("week").toISOString(),
                    le: moment().endOf("week").toISOString(),
                  },
                };
              } else if (selectedOption === "This Month") {
                filter = {
                  createdAt: {
                    ge: moment().startOf("month").toISOString(),
                    le: moment().endOf("month").toISOString(),
                  },
                };
              } else if (selectedOption === "This Year") {
                filter = {
                  createdAt: {
                    ge: moment().startOf("year").toISOString(),
                    le: moment().endOf("year").toISOString(),
                  },
                };
              } else if (selectedOption === "Custom") {
                // filter = {
                //   createdAt: {
                //     ge: moment(startDate).startOf("day").toISOString(),
                //     le: moment(endDate).endOf("day").toISOString(),
                //   },
                // };
              }
              console.log("filter", filter);
              const promises = filterdata.map(async (siteee) => {
                return client.graphql({
                  query: queries.assetsBySitedetailsID,
                  variables: {
                    sitedetailsID: siteee.id,
                    filter: filter,
                    limit: limit,
                  },
                });
              });
              Promise.all(promises)
                .then((results) => {
                  const testReport1 = [];
                  results.forEach((result1) => {
                    const assetList = result1.data.assetsBySitedetailsID.items;
                    console.log(assetList);
                    if (assetList.length > 0) {
                      console.log(assetList);
                      const filtersites = assetList.filter(
                        (item) => item.sitedetailsID === selectedSiteGlobal
                      );
                      console.log(filtersites);
                      const data = selectedSiteGlobal ? filtersites : assetList;
                      testReport1.push(...data);
                    }
                  });
                  console.log("final data");
                  setTestingAsset(testReport1);
                  console.log(testReport1);
                  ////fetchTestingss(testReport1)
                  if (testReport1.length > 0) {
                    ////fetchTestingss(testReport1);
                    //fetchRepairss(testReport1);
                  } else {
                    setNextTesting([]);
                    setRepair([]);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } else {
              setNextTesting([]);
              setRepair([]);
            }
          }
        });
      }
    }
  }

  //---repair
  async function fetchRepairss(assets) {
    if (assets.length > 0) {
      let nextToken = "";
      let repair = [];
      for (let item of assets) {
        const result = await client.graphql({
          query: queries.repairsByAssetsID,
          variables: {
            assetsID: item.id,
            limit: limit,
          },
          authMode: "API_KEY",
        });
        if (result.data.repairsByAssetsID.items.length > 0) {
          let assetDatas = result.data.repairsByAssetsID.items;
          nextToken = result.data.repairsByAssetsID.nextToken;
          if (result.data.repairsByAssetsID.items.length > 0) {
            repair.push(assetDatas);
          }
          while (nextToken !== null) {
            const results = await client.graphql({
              query: queries.repairsByAssetsID,
              variables: {
                limit: limit,
                assetsID: item.id,
                nextToken: nextToken,
              },
              authMode: "API_KEY",
            });
            if (results.data.repairsByAssetsID.items.length > 0) {
              nextToken = results.data.repairsByAssetsID.nextToken;
              if (results.data.repairsByAssetsID.items.length > 0) {
                repair.push(results.data.repairsByAssetsID.items);
              }
            }
          }
          console.log(repair);
          if (repair.length > 0) {
            const mergeAssets = repair.flat(1);
            console.log(mergeAssets);
            setRepair(mergeAssets);
          } else {
            setRepair([]);
          }
        }
      }
    }
  }

  // async function fetchRepairDetails(testingData, onDateRangeSelected) {
  //   //---Week--
  //   const currentDate = new Date();
  //   const currentDayOfWeek = currentDate.getDay();
  //   const startOfWeek = new Date(
  //     currentDate.getFullYear(),
  //     currentDate.getMonth(),
  //     currentDate.getDate() - currentDayOfWeek
  //   );
  //   const endOfWeek = new Date(
  //     currentDate.getFullYear(),
  //     currentDate.getMonth(),
  //     currentDate.getDate() + (6 - currentDayOfWeek)
  //   );
  //   // ---Month
  //   const startOfMonth = new Date(
  //     currentDate.getFullYear(),
  //     currentDate.getMonth(),
  //     1
  //   );
  //   const endOfMonth = new Date(
  //     currentDate.getFullYear(),
  //     currentDate.getMonth() + 1,
  //     0
  //   );
  //   // ---year
  //   const startOfThisYear = new Date(currentDate.getFullYear(), 0, 1);
  //   const endOfThisYear = new Date(currentDate.getFullYear(), 11, 31);
  //   //---custom -----
  //   const [startDate, endDate] = dateRange;
  //   let testingDetails = [];
  //   let monthArray = [];
  //   let countsArray = [];
  //   setIsLoading(true);
  //   let filter = {};
  //   if (onDateRangeSelected === "Today") {
  //     filter = {
  //       createdAt: {
  //         ge: moment().startOf("day").toISOString(),
  //         lt: moment().endOf("day").toISOString(),
  //       },
  //     };
  //   } else if (onDateRangeSelected === "This Week") {
  //     filter = {
  //       createdAt: {
  //         ge: moment().startOf("week").toISOString(),
  //         lt: moment().endOf("week").toISOString(),
  //       },
  //     };
  //   } else if (onDateRangeSelected === "This Month") {
  //     filter = {
  //       createdAt: {
  //         ge: moment().startOf("month").toISOString(),
  //         lt: moment().endOf("month").toISOString(),
  //       },
  //     };
  //   } else if (onDateRangeSelected === "This Year") {
  //     filter = {
  //       createdAt: {
  //         ge: moment().startOf("year").toISOString(),
  //         lt: moment().endOf("year").toISOString(),
  //       },
  //     };
  //   } else if (onDateRangeSelected === "Custom") {
  //     filter = {
  //       createdAt: {
  //         ge: moment(startDate).startOf("day").toISOString(),
  //         lt: moment(endDate).endOf("day").toISOString(),
  //       },
  //     };
  //   }
  //   console.log("filter", filter);
  //   console.log(testingData);
  //   let nextToken2 = "";
  //   let assets2 = [];
  //   let nextToken = "";
  //   let assetTemplates = [];
  //   const dataDetails = await client.graphql({
  //     query: queries.listAssetTemplates,
  //     authMode: "API_KEY",
  //     variables: {
  //       limit: 200000,
  //     },
  //   });
  //   if (dataDetails.data.listAssetTemplates.items.length > 0) {
  //     let assetDatas = dataDetails.data.listAssetTemplates.items;
  //     nextToken = dataDetails.data.listAssetTemplates.nextToken;
  //     if (dataDetails.data.listAssetTemplates.items.length > 0) {
  //       assetTemplates.push(assetDatas);
  //     }
  //     while (nextToken !== null) {
  //       const dataDetailss = await client.graphql({
  //         query: queries.listAssetTemplates,
  //         variables: {
  //           limit: 200000,
  //           nextToken: nextToken,
  //         },
  //         authMode: "API_KEY",
  //       });
  //       if (dataDetailss.data.listAssetTemplates.items.length > 0) {
  //         nextToken = dataDetailss.data.listAssetTemplates.nextToken;
  //         if (dataDetailss.data.listAssetTemplates.items.length > 0) {
  //           assetTemplates.push(dataDetailss.data.listAssetTemplates.items);
  //         }
  //       }
  //     }
  //     console.log(assetTemplates);
  //     if (assetTemplates.length > 0) {
  //       const mergeAssetTemplates = assetTemplates.flat(1);
  //       let count = 0;
  //       //--
  //       for (let assetTemplate of mergeAssetTemplates) {
  //         count = count + 1;
  //         for (let sites of testingData) {
  //           let tempSiteId = assetTemplate.id + "_" + sites.id;
  //           const result = await client
  //             .graphql({
  //               query: queries.repairsByAssettemplateSiteID,
  //               variables: {
  //                 assettemplateSiteID: tempSiteId,
  //                 filter: filter,
  //                 limit: 1000,
  //               },
  //               authMode: "API_KEY",
  //             });
  //           if (result.data.repairsByAssettemplateSiteID.items.length > 0) {
  //             let assetDatas = result.data.repairsByAssettemplateSiteID.items;
  //             nextToken2 = result.data.repairsByAssettemplateSiteID.nextToken;
  //             if (result.data.repairsByAssettemplateSiteID.items.length > 0) {
  //               assets2.push(assetDatas);
  //             }
  //             while (nextToken2 !== null) {
  //               const results = await client
  //                 .graphql({
  //                   query: queries.repairsByAssettemplateSiteID,
  //                   variables: {
  //                     assettemplateSiteID: tempSiteId,
  //                     filter: filter,
  //                     limit: 1000,
  //                     nextToken: nextToken2,
  //                   },
  //                   authMode: "API_KEY",
  //                 })
  //               if (results.data.repairsByAssettemplateSiteID.items.length > 0) {
  //                 nextToken2 = results.data.repairsByAssettemplateSiteID.nextToken;
  //                 if (results.data.repairsByAssettemplateSiteID.items.length > 0) {
  //                   assets2.push(results.data.repairsByAssettemplateSiteID.items);
  //                 }
  //               }
  //               else {
  //                 nextToken2 = results.data.repairsByAssettemplateSiteID.nextToken;
  //               }
  //             }
  //           }
  //         }
  //         if (count === mergeAssetTemplates.length) {
  //           if (assets2.length > 0) {
  //             const mergeAssets2 = assets2.flat(1);
  //             testingDetails = mergeAssets2;
  //             console.log("repair count", testingDetails)

  //             setIsLoading(false);
  //             setRepair(testingDetails);
  //           } else {
  //             setIsLoading(false);
  //             setRepair([]);
  //           }
  //         }
  //       }
  //     }
  //   }

  //   return () => client.cancel();
  // }

  //---testingssss
  // async function fetchTestingss(assets, onDateRangeSelected) {
  //   if (assets.length > 0) {
  //     let nextToken = "";
  //     let testing = [];
  //     let filter = {};
  //     if (onDateRangeSelected === "Today") {
  //       filter = {
  //         createdAt: {
  //           ge: moment().startOf("day").toISOString(),
  //           le: moment().endOf("day").toISOString(),
  //         },
  //       };
  //     } else if (onDateRangeSelected === "This Week") {
  //       filter = {
  //         createdAt: {
  //           ge: moment().startOf("week").toISOString(),
  //           le: moment().endOf("week").toISOString(),
  //         },
  //       };
  //     } else if (onDateRangeSelected === "This Month") {
  //       filter = {
  //         createdAt: {
  //           ge: moment().startOf("month").toISOString(),
  //           le: moment().endOf("month").toISOString(),
  //         },
  //       };
  //     } else if (onDateRangeSelected === "This Year") {
  //       filter = {
  //         createdAt: {
  //           ge: moment().startOf("year").toISOString(),
  //           le: moment().endOf("year").toISOString(),
  //         },
  //       };
  //     } else if (onDateRangeSelected === "Custom") {
  //       // filter = {
  //       //   createdAt: {
  //       //     ge: moment(startDate).startOf("day").toISOString(),
  //       //     le: moment(endDate).endOf("day").toISOString(),
  //       //   },
  //       // };
  //     }
  //     console.log("filter", filter);
  //     for (let item of assets) {
  //       const result = await client.graphql({
  //         query: queries.testingsBySitedetailsID,
  //         variables: {
  //           sitedetailsID: item.id,
  //           filter: filter,
  //           limit: limit,
  //         },
  //         authMode: "API_KEY",
  //       });
  //       //if (result.data.testingsBySitedetailsID.items.length > 0) {
  //       let assetDatas = result.data.testingsBySitedetailsID.items;
  //       nextToken = result.data.testingsBySitedetailsID.nextToken;
  //       if (result.data.testingsBySitedetailsID.items.length > 0) {
  //         testing.push(assetDatas);
  //       }
  //       while (nextToken !== null) {
  //         const results = await client.graphql({
  //           query: queries.testingsBySitedetailsID,
  //           variables: {
  //             limit: limit,
  //             sitedetailsID: item.id,
  //             filter: filter,
  //             nextToken: nextToken,
  //           },
  //           authMode: "API_KEY",
  //         });
  //         if (results.data.testingsBySitedetailsID.items.length > 0) {
  //           nextToken = results.data.testingsBySitedetailsID.nextToken;
  //           if (results.data.testingsBySitedetailsID.items.length > 0) {
  //             testing.push(results.data.testingsBySitedetailsID.items);
  //           }
  //         }
  //         else {
  //           nextToken = null;
  //         }
  //       }
  //       console.log(testing);
  //       if (testing.length > 0) {
  //         const mergeAssets = testing.flat(1);
  //         console.log(mergeAssets);
  //         setNextTesting(mergeAssets);
  //         setTesting(mergeAssets);
  //       } else {
  //         setNextTesting([]);
  //         setTesting([]);
  //       }
  //       // }
  //       // else {
  //       //   setNextTesting([]);
  //       //   setTesting([]);
  //       // }
  //     }
  //   }
  // }

  async function fetchRepairDetails(assets, onDateRangeSelected) {
    if (!assets || assets.length === 0) {
      setRepair(0);
      return;
    }

    const siteIds = assets.map(asset => asset.id);
    console.log("sitesIds", siteIds);

    const chunkSize = 10;
    const chunks = [];
    for (let i = 0; i < siteIds.length; i += chunkSize) {
      chunks.push(siteIds.slice(i, i + chunkSize));
    }

    try {
      const allResults = [];

      for (const chunk of chunks) {
        console.log("Fetching repair chunk:", chunk);
        const result = await client.graphql({
          query: queries.getRepairSummary,
          variables: {
            onDateRange: onDateRangeSelected,
            siteIds: chunk,
          },
          authMode: "API_KEY",
        });

        if (result.data?.getRepairSummary) {
          allResults.push(...result.data.getRepairSummary);
        }
      }

      // Optional parallel version (use only if each batch runs fast)
      /*
      const promises = chunks.map(chunk =>
        client.graphql({
          query: queries.getRepairSummary,
          variables: {
            onDateRange: onDateRangeSelected,
            siteIds: chunk,
          },
          authMode: "API_KEY",
        })
      );
  
      const responses = await Promise.all(promises);
      const allResults = responses.flatMap(res => res.data?.getRepairSummary || []);
      */

      console.log("Merged repair results:", allResults);

      const mergedAssets = assets.map(asset => {
        const summary = allResults.find(s => s.sitedetailsID === asset.id);
        return {
          ...asset,
          totalRepairs: summary ? summary.totalRepairs : 0,
        };
      });

      const totalCount = mergedAssets.reduce((sum, item) => sum + (item.totalRepairs || 0), 0);

      console.log("Total Repairs:", totalCount);
      setRepair(totalCount);

    } catch (error) {
      console.error("Error fetching repair summary:", error);
      setRepair(0);
    }
  }


  async function fetchTestingss(assets, onDateRangeSelected) {
    if (!assets || assets.length === 0) {
      setTesting([]);
      setNextTesting([]);
      return;
    }

    const siteIds = assets.map(asset => asset.id);
    console.log("sitesIds", siteIds);

    const chunkSize = 10;
    const chunks = [];
    for (let i = 0; i < siteIds.length; i += chunkSize) {
      chunks.push(siteIds.slice(i, i + chunkSize));
    }

    try {
      const allResults = [];

      for (const chunk of chunks) {
        console.log("Fetching chunk:", chunk);
        const result = await client.graphql({
          query: queries.getTestingCountSummary,
          variables: {
            onDateRange: onDateRangeSelected,
            siteIds: chunk,
          },
          authMode: "API_KEY",
        });

        if (result.data?.getTestingCountSummary) {
          allResults.push(...result.data.getTestingCountSummary);
        }
      }

      // Option 2 (Optional): Parallel version for speed (only if Lambda is fast)
      /*
      const promises = chunks.map(chunk =>
        client.graphql({
          query: queries.getTestingCountSummary,
          variables: {
            onDateRange: onDateRangeSelected,
            siteIds: chunk,
          },
          authMode: "API_KEY",
        })
      );
      const responses = await Promise.all(promises);
      const allResults = responses.flatMap(res => res.data?.getTestingCountSummary || []);
      */

      console.log("Merged results:", allResults);

      const mergedAssets = assets.map(asset => {
        const summary = allResults.find(s => s.sitedetailsID === asset.id);
        return {
          ...asset,
          totalTests: summary ? summary.totalTests : 0,
        };
      });

      const totalCount = mergedAssets.reduce((sum, item) => sum + (item.totalTests || 0), 0);

      console.log("Total Tests:", totalCount);
      setTesting(mergedAssets);
      setNextTesting(totalCount);

    } catch (error) {
      console.error("Error fetching testing summary:", error);
      setTesting([]);
      setNextTesting(0);
    }
  }

  // pending tasks su
  // async function fetchTasks(sitesss, onDateRangeSelected) {
  //   //---
  //   // const response3 = await client.graphql({
  //   //   query: queries.linkUsersAndSitesByUserdetailsID,
  //   //   authMode: "API_KEY",
  //   //   variables: {
  //   //     userdetailsID: LoginUserDetails.id,
  //   //     filter: {
  //   //       status: {
  //   //         eq: "Active",
  //   //       },
  //   //     },
  //   //     limit: limit,
  //   //   },
  //   // });
  //   // if (response3.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
  //   //   console.log(response3);
  //   //   const siteDetails = response3.data.linkUsersAndSitesByUserdetailsID.items;
  //   if (sitesss.length > 0) {
  //     //---
  //     let nextToken = "";
  //     let assets = [];
  //     let filter = {};
  //     if (onDateRangeSelected === "Today") {
  //       filter = {
  //         createdAt: {
  //           ge: moment().startOf("day").toISOString(),
  //           le: moment().endOf("day").toISOString(),
  //         },
  //         status: {
  //           eq: "Active"
  //         }
  //         // taskStatus: {
  //         //   ne: "Pending",
  //         // },
  //       };
  //     } else if (onDateRangeSelected === "This Week") {
  //       filter = {
  //         createdAt: {
  //           ge: moment().startOf("week").toISOString(),
  //           le: moment().endOf("week").toISOString(),
  //         },
  //         status: {
  //           eq: "Active"
  //         }
  //         // taskStatus: {
  //         //   ne: "Pending",
  //         // },
  //       };
  //     } else if (onDateRangeSelected === "This Month") {
  //       filter = {
  //         createdAt: {
  //           ge: moment().startOf("month").toISOString(),
  //           le: moment().endOf("month").toISOString(),
  //         },
  //         status: {
  //           eq: "Active"
  //         }
  //         // taskStatus: {
  //         //   ne: "Pending",
  //         // },
  //       };
  //     } else if (onDateRangeSelected === "This Year") {
  //       filter = {
  //         createdAt: {
  //           ge: moment().startOf("year").toISOString(),
  //           le: moment().endOf("year").toISOString(),
  //         },
  //         status: {
  //           eq: "Active"
  //         }
  //         // taskStatus: {
  //         //   ne: "Pending",
  //         // },
  //       };
  //     }
  //     else if (onDateRangeSelected === "All Time") {
  //       filter = {
  //         // createdAt: {
  //         //   ge: moment().startOf("year").toISOString(),
  //         //   le: moment().endOf("year").toISOString(),
  //         // },
  //         status: {
  //           eq: "Active"
  //         }
  //         // taskStatus: {
  //         //   ne: "Pending",
  //         // },
  //       };
  //     }
  //     else if (onDateRangeSelected === "Custom") {
  //       // filter = {
  //       //   createdAt: {
  //       //     ge: moment(startDate).startOf("day").toISOString(),
  //       //     le: moment(endDate).endOf("day").toISOString(),
  //       //   },
  //       // };
  //     }
  //     console.log("filter", filter);
  //     let count = 0;
  //     for (let site of sitesss) {
  //       count++;
  //       const result = await client.graphql({
  //         query: queries.tasksBySitedetailsID,
  //         variables: {
  //           sitedetailsID: site.id,
  //           filter: filter,
  //           limit: limit,
  //         },
  //         authMode: "API_KEY",
  //       });
  //       if (result.data.tasksBySitedetailsID.items.length > 0) {
  //         let assetDatas = result.data.tasksBySitedetailsID.items;
  //         nextToken = result.data.tasksBySitedetailsID.nextToken;
  //         if (result.data.tasksBySitedetailsID.items.length > 0) {
  //           assets.push(assetDatas);
  //         }
  //         while (nextToken !== null) {
  //           const results = await client.graphql({
  //             query: queries.tasksBySitedetailsID,
  //             variables: {
  //               sitedetailsID: site.id,
  //               filter: filter,
  //               limit: limit,
  //               nextToken: nextToken,
  //             },
  //             authMode: "API_KEY",
  //           });
  //           if (results.data.tasksBySitedetailsID.items.length > 0) {
  //             nextToken = results.data.tasksBySitedetailsID.nextToken;
  //             if (results.data.tasksBySitedetailsID.items.length > 0) {
  //               assets.push(results.data.tasksBySitedetailsID.items);
  //             }
  //           }
  //         }
  //         console.log(assets);
  //       }
  //       else {
  //         settasks([]);
  //       }
  //       if (count === sitesss.length) {
  //         if (assets.length > 0) {
  //           const mergeAssets = assets.flat(1);
  //           console.log(mergeAssets);
  //           //---
  //           const sortItemsnew = mergeAssets.sort((a, b) => {
  //             return new Date(b.createdAt) - new Date(a.createdAt);
  //           });
  //           const filterTasks = mergeAssets.filter((item) => {
  //             const siteArray = JSON.parse(item.taskCompletionLink).map(
  //               (link) => link.site
  //             );
  //             return siteArray.includes(selectedSiteGlobal);
  //           });
  //           console.log(sortItemsnew);
  //           const sortItems = selectedSiteGlobal ? filterTasks : sortItemsnew;
  //           console.log(sortItems);
  //           settasks(sortItems);

  //           //--
  //         } else {
  //           settasks([]);
  //         }
  //       }
  //     }
  //   } else {
  //     settasks([]);
  //   }
  //   //}
  // }

  async function fetchTasks(assets, onDateRangeSelected) {
    if (!assets || assets.length === 0) {
      setTesting([]);
      setNextTesting([]);
      return;
    }

    const siteIds = assets.map(asset => asset.id);
    console.log("sitesIds", siteIds);

    try {
      const result = await client.graphql({
        query: queries.getTaskSummary,
        variables: {
          onDateRange: onDateRangeSelected,
          siteIds: siteIds,
        },
        authMode: "API_KEY",
      });
      console.log("resultssss", result);
      const summaries = result.data.getTaskSummary;

      if (summaries && summaries.length > 0) {
        const mergedAssets = assets.map(asset => {
          const summary = summaries.find(s => s.sitedetailsID === asset.id);
          return {
            ...asset,
            totalTasks: summary ? summary.totalTasks : 0,
          };
        });

        const totalCount = mergedAssets.reduce((sum, item) => sum + (item.totalTasks || 0), 0);

        console.log("Total Tasks:", totalCount);
        console.log("data", mergedAssets);

        settasksSU(totalCount);

      } else {
        settasksSU(0);
      }

    } catch (error) {
      console.error("Error fetching testing summary:", error);
    }
  }

  async function fetchTasksSPLogin(onDateRangeSelected) {
    //---
    let nextToken = "";
    let assets = [];
    let filter = {};
    if (onDateRangeSelected === "Today") {
      filter = {
        createdAt: {
          ge: moment().startOf("day").toISOString(),
          le: moment().endOf("day").toISOString(),
        },
        status: {
          eq: "Active"
        }
        // taskStatus: {
        //   ne: "Pending",
        // },
      };
    } else if (onDateRangeSelected === "This Week") {
      filter = {
        createdAt: {
          ge: moment().startOf("week").toISOString(),
          le: moment().endOf("week").toISOString(),
        },
        status: {
          eq: "Active"
        }
        // taskStatus: {
        //   ne: "Pending",
        // },
      };
    } else if (onDateRangeSelected === "This Month") {
      filter = {
        createdAt: {
          ge: moment().startOf("month").toISOString(),
          le: moment().endOf("month").toISOString(),
        },
        status: {
          eq: "Active"
        }
        // taskStatus: {
        //   ne: "Pending",
        // },
      };
    } else if (onDateRangeSelected === "This Year") {
      filter = {
        createdAt: {
          ge: moment().startOf("year").toISOString(),
          le: moment().endOf("year").toISOString(),
        },
        status: {
          eq: "Active"
        }
        // taskStatus: {
        //   ne: "Pending",
        // },
      };
    } else if (onDateRangeSelected === "All Time") {
      filter = {
        // createdAt: {
        //   ge: moment().startOf("year").toISOString(),
        //   le: moment().endOf("year").toISOString(),
        // },
        status: {
          eq: "Active"
        }
        // taskStatus: {
        //   ne: "Pending",
        // },
      };
    }
    else if (onDateRangeSelected === "Custom") {
      // filter = {
      //   createdAt: {
      //     ge: moment(startDate).startOf("day").toISOString(),
      //     le: moment(endDate).endOf("day").toISOString(),
      //   },
      // };
    }
    console.log("filter", filter);
    const result = await client.graphql({
      query: queries.tasksBySpcompanydetailsID,
      variables: {
        spcompanydetailsID: LoginUserDetails.companyDetailsId,
        filter: filter,
        limit: limit,
      },
      authMode: "API_KEY",
    });
    if (result.data.tasksBySpcompanydetailsID.items.length > 0) {
      let assetDatas = result.data.tasksBySpcompanydetailsID.items;
      nextToken = result.data.tasksBySpcompanydetailsID.nextToken;
      if (result.data.tasksBySpcompanydetailsID.items.length > 0) {
        assets.push(assetDatas);
      }
      while (nextToken !== null) {
        const results = await client.graphql({
          query: queries.tasksBySpcompanydetailsID,
          variables: {
            spcompanydetailsID: LoginUserDetails.companyDetailsId,
            filter: filter,
            limit: limit,
            nextToken: nextToken,
          },
          authMode: "API_KEY",
        });
        if (results.data.tasksBySpcompanydetailsID.items.length > 0) {
          nextToken = results.data.tasksBySpcompanydetailsID.nextToken;
          if (results.data.tasksBySpcompanydetailsID.items.length > 0) {
            assets.push(results.data.tasksBySpcompanydetailsID.items);
          }
        }
        else {
          nextToken = results.data.tasksBySpcompanydetailsID.nextToken;
        }
      }
      console.log(assets);
      if (assets.length > 0) {
        const mergeAssets = assets.flat(1);
        console.log(mergeAssets);
        //---
        const filterTasks = mergeAssets.filter((item) => {
          const siteArray = JSON.parse(item.taskCompletionLink).map(
            (link) => link.site
          );
          return siteArray.includes(selectedSiteGlobal);
        });

        const sortItemsnew = mergeAssets.sort((a, b) => {
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
        console.log(sortItemsnew);
        const sortItems = selectedSiteGlobal ? filterTasks : sortItemsnew;
        console.log(sortItems);
        settasks(sortItems);

        //--
      } else {
        settasks([]);
      }
    }
    else {
      settasks([]);
    }
  }

  const getLast7Days = () => {
    const days = [];
    for (let i = 6; i >= 0; i--) {
      const d = new Date();
      d.setDate(d.getDate() - i);
      days.push(d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" }));
    }
    return days;
  };

  const last7Days = getLast7Days();


  const optionstests = {
    chart: {
      id: "tests-area",
      type: "area",
      toolbar: { show: false },
    },
    xaxis: {
      type: "category",
      categories: last7Days,
    },
    yaxis: {
      min: 0,
      forceNiceScale: true,
      title: { text: "Number of Tests" },
    },
    dataLabels: { enabled: false },
    stroke: { curve: "smooth" },
    grid: { borderColor: "#e7e7e7", strokeDashArray: 4 },
  };

  const optionsrepairs = {
    chart: {
      id: "repairs-area",
      type: "area",
      toolbar: { show: false },
    },
    xaxis: {
      type: "category",
      categories: last7Days,
      //title: { text: "Date" },
    },
    yaxis: {
      min: 0,
      forceNiceScale: true,
      title: { text: "Number of Repairs" },
    },
    dataLabels: { enabled: false },
    stroke: { curve: "smooth" },
    grid: { borderColor: "#e7e7e7", strokeDashArray: 4 },
  };

  const renderList = (
    <Fragment>
      <Container fluid={true} className="ecommerce-dash">
        <Row>
          <Col md="9">
            <H5>Date Range Picker</H5>
            <span>
              {" "}
              <DateRangePicker
                onDateRangeSelected={onDateRangeSelected}
              ></DateRangePicker>{" "}
            </span>
          </Col>
        </Row>
        <br></br>
        <Row>
          <Row>
            <Col md="4" className="dash-lg-50 box-col-12">
              <Card className="crypto-chart">
                <CardHeader className="card-no-border">
                  <Media>
                    <Media body>
                      <div className="coin-logo-img">
                        {/* <BitCoinSvg />*/}
                        <div>
                          <H5>
                            {selectedOption === "All Time" && !selectedSiteGlobal
                              ? (fulldata[0]?.repairsCount ?? 0)
                              : repair}
                          </H5>
                        </div>
                      </div>
                    </Media>
                    <div className="media-end">
                      <H5>
                        Repairs
                      </H5>
                    </div>
                  </Media>
                </CardHeader>
              </Card>
            </Col>
            <Col md="4" className="dash-lg-50 box-col-12">
              <Card className="crypto-chart">
                <CardHeader className="card-no-border">
                  <Media>
                    <Media body>
                      <div className="coin-logo-img">
                        {/* <BitCoinSvg />*/}
                        <div>
                          <H5>
                            {selectedOption === "All Time" && !selectedSiteGlobal
                              ? (fulldata[0]?.testsCount ?? 0)
                              : nextTesting}
                          </H5>
                        </div>
                      </div>
                    </Media>
                    <div className="media-end">
                      <H5>
                        Tests
                      </H5>
                    </div>
                  </Media>
                </CardHeader>
              </Card>
            </Col>
            <Col md="4" className="dash-lg-50 box-col-12">
              <Card className="crypto-chart">
                <CardHeader className="card-no-border">
                  <Media>
                    <Media body>
                      <div className="coin-logo-img">
                        {/* <BitCoinSvg />*/}
                        <div>
                          <H5>
                            {LoginUserGroup === "site_user" ? tasksSU : tasks.length}
                          </H5>
                        </div>
                      </div>
                    </Media>
                    <div className="media-end">
                      <H5>
                        Tasks
                      </H5>
                    </div>
                  </Media>
                </CardHeader>
              </Card>
            </Col>
          </Row>
        </Row>
        <Row>
          <Col sm="12" xl="6" className="box-col-6">
            <Card>
              <CommenHeader title="Past 7 days Tests" />
              <CardBody>
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: "350px" }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div id="basic-apex">
                    <Chart
                      options={optionstests}
                      series={series}
                      height="350"
                      type="area"
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          <Col sm="12" xl="6" className="box-col-6">
            <Card>
              <CommenHeader title="Past 7 days Repairs" />
              <CardBody>
                {loadingrepair ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: "350px" }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div id="basic-apex">
                    <Chart
                      options={optionsrepairs}
                      series={seriesrepair}
                      height="350"
                      type="area"
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
  return <div>{isLoading ? <LoadingSpinner /> : renderList}</div>;
};
export default DefaultContain;
